import {useState} from 'react'
import {HiMenuAlt2} from 'react-icons/hi'
import theFoxTextLogo from './../assets/images/theFoxTextLogo.png'

const NavBar = () => {
    const [nav, setNav] = useState(false)
    const handleNav = () => {
        setNav(!nav)
        if (!nav) {
            document.body.style.overflow = 'hidden';  // Prevent background scroll
        } else {
            document.body.style.overflow = 'auto';  // Re-enable scroll
        }
    }

  return (
    <div className='w-full flex items-center fixed bg-white h-16 z-30'>
        <HiMenuAlt2 onClick={handleNav} className={nav ? 'z-20 text-white cursor-pointer ml-4 fade-in duration-500' : 'z-20 text-black cursor-pointer ml-4 fade-in duration-500'} size={25} />
        <div className={nav ? 'ease-in duration-300 fixed text-gray-300 left-0 top-0 w-full h-screen bg-black/90 px-4 py-7 flex-col z-10 overflow-y-auto' 
            : 'absolute top-0 h-screen left-[-200%] ease-in duration-500 z-10'}>
            <ul className='flex flex-col w-full h-fulll items-center justify-center text-center'>
                <li className='font-bold text-3xl p-8'>
                    <a href='/'>Home</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/menus'>Menus</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/burrow'>BURROW</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/seafoodLounge'>The Seafood Lounge</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/christmas'>Christmas</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/rooms'>Our Rooms</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/weddings'>Weddings</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='/events'>Events</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='https://www.opentable.co.uk/r/the-fox-inn-reservations-stourbridge?restref=161223&lang=en-GB&ot_source=Restaurant%20website'>Book Now</a>
                </li>
                <li className='font-bold text-3xl p-8'>
                    <a href='https://app.squareup.com/gift/MLAJ92HP6N2GC/order'>Gift Cards</a>
                </li>
                <li className='font-bold text-3xl p-8 pb-32'>
                    <a href='/contact'>Contact Us & Opening Hours</a>
                </li>
            </ul>
        </div>
        <div className='absolute w-full flex p-4 pt-4 items-center justify-center'>
            <a className='w-[30%] md:w-[246px]' href="/">
                <img src={theFoxTextLogo} href='/' alt="the fox text logo" />
            </a>
        </div>
        <a href="/menus" className="absolute right-4 bg-white text-black border-2 border-black px-4 py-1 rounded-full font-bold hover:bg-black hover:text-white transition-all duration-300 sm:px-4 sm:py-1 sm:text-sm md:px-6 md:py-2 md:text-base tracking-widest">
            MENUS
        </a>
    </div>
  )
}

export default NavBar